module.exports = __webpack_public_path__ + "img/story013.5dd4194e.webp";